/*global angular*/

module.exports = [function () {
  'use strict';
  return {
    restrict: 'E',
    template: require('./searchResultItem.html'),
    replace: true,
    transclude: true,
    scope: {
      result: '<'
    },
    link: function (scope) {
      /**
       * In the case of practical examples, we only show paragraphs in search results, and under some...
       * ... conditions, which are basically that said practical example does not includes a...
       * ... description or referenced generic goals in the search result context
       */
      scope.showParagraphsInSearchResults = function () {
        var context = scope.result.context;
        return context.paragraphs && context.paragraphs.length > 0 && !context.referencedGenericGoals;
      };
    }
  };
}];



// WEBPACK FOOTER //
// ./web/js/module/practicalExample/js/searchResultItem/searchResultItem.js